import { render } from "./ClassAnnouncementDetails.vue?vue&type=template&id=6512928e"
import script from "./ClassAnnouncementDetails.vue?vue&type=script&lang=js"
export * from "./ClassAnnouncementDetails.vue?vue&type=script&lang=js"

import "./ClassAnnouncementDetails.vue?vue&type=style&index=0&id=6512928e&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__